import React, { useState, useEffect } from "react";
import "./HeweTxn.css";
import axios from "axios";
import { CSVLink } from "react-csv";
import { Link, useHistory, useParams } from "react-router-dom";

import toast, { Toaster } from 'react-hot-toast';

import constantObject from "../../config";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Loader from "../../components/Loader";
import { localTimeConvert, formatTimes } from "../../common/Functions";
import LinearProgressBarWithLabel from "../../components/LinearProgressBar";

import { FaEye } from "react-icons/fa";
import { IoMdCopy } from "react-icons/io";
import { RiSearchLine } from 'react-icons/ri';
import { GoArrowUpRight } from "react-icons/go";
import { IoHelpCircleOutline } from "react-icons/io5";

import bulb from "../../assets/images/Vector.png";
import csvicon from "../../assets/images/csv-icon.png";

import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { Tooltip, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const HeweTransactions = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [cardValue, setCardValue] = useState({});
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [holdersData, setHoldersData] = useState([]);
  const [holderTotalCount, setHolderTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [exportedData, setExportedData] = useState([]);
  const [buttonType, setButtonType] = useState("1");
  const [query, setQuery] = useState('');

  const [hewePrice, setHewePrice] = useState();

  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const handleOpenPopup = (data) => {
    setPopupData(data);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };


  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  
  function formatNumber(num) {
    if (num >= 1e12) {
      return (num / 1e12).toFixed(2) + " Trillion";
    }
    if (num >= 1e9) {
      return (num / 1e9).toFixed(2) + " Billion";
    }
    if (num >= 1e6) {
      return (num / 1e6).toFixed(2) + " Million";
    }
  }

  function formatNumberMaxCap(num) {
    if (num >= 1e12) {
      return Math.floor(num / 1e12) + " Trillion";
    }
    if (num >= 1e9) {
      return Math.floor(num / 1e9) + " Billion";
    }
    if (num >= 1e6) {
      return Math.floor(num / 1e6) + " Million";
    }
    return Math.floor(num);
  }

  const cardData = [
    {
      title: "Total Supply",
      value: `${formatNumber(cardValue?.totalSupply || 0)} HEWE`,
    },
    {
      title: "Circulating Supply",
      value: `${formatNumber(cardValue?.currentCirculation || 0)} HEWE`,
    },
    {
      title: "Burned Supply",
      value: `${formatNumber(cardValue?.burnSupply || 0)} HEWE`,
    },
    {
      title: "Maximum Supply",
      // value: `${formatNumber(cardValue?.maxCap || 0)} HEWE`,
      value: `${formatNumberMaxCap(cardValue?.maxCap || 0)} HEWE`,
    },
    {
      title: "Total holders",
      value: `${cardValue?.totalHolders}`,
    },
    {
      title: "Price",
      value: hewePrice ? `$${hewePrice}` : '$0'
    },
  ];

  const cardData1 = [
    // {
    //   heading: "Overview",
    //   title1: "Max total supply",
    //   value1: `${formatNumber(cardValue?.totalSupply || 0)} HEWE`,
    //   title2: "Holders",
    //   value2: `${cardValue.totalHolders}`,
    //   title3: "Total transfers",
    //   value3: `${cardValue?.totalTransferCount}`,
    // },
    // {
    //   heading: "Market",
    //   title1: "Price",
    //   value1: `${cardValue?.price || 0}`,
    //   title2: "On chain market cap",
    //   value2: `${cardValue?.onChainMarket || 0}`,
    //   title3: "Circulating Supply Market Cap",
    //   value3: `${cardValue?.circulatingSupply || 0}`,
    // },
    {
      heading: "HEWE Contract Address",
      title1: "Token Contract",
      value1: `0xe8415D460fE26636CC487fE20A5a87849055C952`,
    },
  ];

  function formatAddress(address) {
    if (!address || address.length <= 16) return address;
    return `${address.slice(0, 8)}...${address.slice(-8)}`;
  }



  //get card value
  const getHeweTransactionCardValue = async () => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/token/hewe/stats`
      );

      setCardValue(response.data);
    } catch (error) {
      console.log("Error fetching card value data:", error);
    }
  };

  //get Hewe Price value
  const getHewePriceValue = async () => {
    try {
      const response = await axios.get(
        `https://dev.hewe.club/api/admin/heweprice`
      );

      setHewePrice(response?.data?.data?.latest);
      console.log("HewePrice", response)
    } catch (error) {
      console.log("Error fetching card value data:", error);
    }
  };
  

  useEffect(() => {
    getHeweTransactionCardValue();
    getHewePriceValue();
  }, []);


  useEffect(() => {
    let intervalId = null;
  
    const fetchTransferData = async () => {
      try {
        const response = await axios.get(
          `${constantObject.BaseUrl}/api/transaction/hewe?limit=${rowsPerPage}&page=${page + 1}`
        );
  
        setTableData(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const fetchHolderData = async () => {
      try {
        const response = await axios.get(
          `${constantObject.BaseUrl}/api/token/hewe/holders?page=${page + 1}&limit=${rowsPerPage}`
        );
  
        setHoldersData(response?.data?.accounts);
        setHolderTotalCount(cardValue?.totalHolders || 0);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    if (buttonType === "1") {
      // Call it immediately
      fetchTransferData();
  
      // Then set interval
      intervalId = setInterval(fetchTransferData, 5000);
    }
  
    if (buttonType === "2") {
      fetchHolderData(); // Only call it when buttonType/page/rowsPerPage change
    }
  
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  
  }, [page, rowsPerPage, buttonType]);  

  // Function to update exported data when table data changes
  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, totalCount);
    const dataForExport = tableData.slice(startIndex, endIndex);

    setExportedData(dataForExport);
  }, [tableData, page, rowsPerPage, totalCount]);


  function formatValue(value) {
    const numberValue = Number(value);
    return !isNaN(numberValue)
      ? numberValue.toLocaleString("en", { maximumFractionDigits: 18 })
      : "N/A";
  }


  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!", {
        style: {
          background: '#4CAF50',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    }).catch((err) => {
      toast.error("Failed to copy!", {
        style: {
          background: '#f44336',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    });
  };

  // For Search Functionalty
  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/search?id=${query}&limit=${rowsPerPage}&page=${page + 1}`
      );

      if (response?.status === 200) {
        if (response?.data?.type === "BLOCK") {
          history.push(`/block_details/${response?.data?.data?.blockNumber}`);
        } else if (response?.data?.type === "TXN_HASH") {
          history.push(`/transactions_detail/${response?.data?.data?.hash}`);
        } else if (response?.data?.type === "ACC_ADDRESS") {
          history.push(`/address/${response?.data?.data?.address}`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // press on enter button call this function
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };


  return (
    <>
      <Navbar />

      {/* loader */}
      {isLoading && <Loader />}

      <div className="card-page-container">
        <header className="address-page-header">
          <h1 className="heading-pending-txn">HEWE</h1>
        </header>

        <div className="six-card-container">
          {cardData.map((card, index) => (
            <div className="card-section" key={index}>
              <div className="card-head">{card.title}</div>
              <div
                className="show-card-data"
                dangerouslySetInnerHTML={{ __html: card.value }}
              />
            </div>
          ))}
        </div>

        <div className="card-container">
          {cardData1.map((card, index) => (
            <div className="big-card-containers" key={index}>
              <div className="big-card-title">{card.heading}</div>

              {/* Title 1 + Value 1 with Copy */}
              <div className="card-key">{card.title1}</div>
              <div className="card-value-with-button contract-address">
                <span
                  style={{ color: "rgb(7, 132, 195)" }}
                  className="card-value"
                  dangerouslySetInnerHTML={{
                    __html:
                      card.heading === "HEWE Contract Address"
                        ? formatAddress(card.value1)
                        : card.value1,
                  }}
                />

                {card.heading === "HEWE Contract Address" && (
                  <div
                    onClick={() => copyToClipboard(card?.value1)}
                    style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                  >
                    <IoMdCopy style={{ fontSize: "1.2rem" }} />
                  </div>
                )}
              </div>

              {/* Title 2 + Value 2 */}
              {card.title2 && (
                <>
                  <div className="card-key">{card.title2}</div>
                  <div
                    className="card-value"
                    dangerouslySetInnerHTML={{ __html: card.value2 }}
                  />
                </>
              )}

              {/* Title 3 + Value 3 */}
              {card.title3 && (
                <>
                  <div className="card-key">{card.title3}</div>
                  <div
                    className="card-value"
                    dangerouslySetInnerHTML={{ __html: card.value3 }}
                  />
                </>
              )}
            </div>
          ))}
        </div>

        <div className="tab-search-container multiple-botton-section">
          <div className="address-button-alignment">
            <button
              className={`multiple-button-style ${
                buttonType === "1" ? "active-button" : ""
              }`}
              onClick={() => {
                setButtonType("1")
              }}
            >
              Transfers
            </button>
            <button
              className={`multiple-button-style ${
                buttonType === "2" ? "active-button" : ""
              }`}
              onClick={() => {
                setButtonType("2");
              }}
            >
              Holders
            </button>
            <button
              className={`multiple-button-style ${
                buttonType === "3" ? "active-button" : ""
              }`}
              onClick={() => {
                setButtonType("3");
              }}
            >
              Info
            </button>
          </div>
          {(buttonType == "1" || buttonType == "2") && (
            <div className="custom-search-cant">
              <input
                type="text"
                placeholder="Search by Txn Hash / Block / Address"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                onKeyDown={handleKeyDown}
                className="custom-search-input"
              />
              <button type="submit" className="custom-search-button" onClick={handleSearch}>
                <RiSearchLine />
              </button>
            </div>
          )}
        </div>

        {buttonType == "3" ? (
          <div className="info-section">
            <div className="info-document">
              <div className="big-card-title">Overview</div>
              <div className="card-value">
                HEWE is a global, open-source platform for decentralized
                applications. HEWE is fueling transactions on the Chain.
              </div>
            </div>

            <div className="info-document">
              <div className="big-card-title">Market</div>
              <div className="market-doc-section">
                <div className="market-doc-cant">
                  <div className="card-value">Volume (24H):</div>
                  <div className="card-value">${cardValue?.volume || 0}</div>
                </div>
                <div className="market-doc-cant">
                  <div className="card-value">Market capitalisation:</div>
                  <div className="card-value">${cardValue?.maxCap || 0}</div>
                </div>
                <div className="market-doc-cant">
                  <div className="card-value">Circulating supply:</div>
                  <div className="card-value">{cardValue?.currentCirculation || 0} HEWE</div>
                </div>
                <div className="market-doc-cant mt-2">
                  <div className="card-value">
                    Update? Click here to update the token ICO / general
                    information
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Paper className="paper-style">
            <div className="top-pagination">
              <div className="total-pending-txn">
                Latest {rowsPerPage} from a total of{" "}
                <span style={{ color: "#0784C3" }}>{buttonType == "1" ? totalCount : holderTotalCount}</span>{" "}
                transactions
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={buttonType == "1" ? totalCount : holderTotalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>

            <TableContainer>
              {buttonType == "1" && (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <IoHelpCircleOutline size={22} color="#6C757D" />
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Txn Hash
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Status
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Method{" "}
                        <IoHelpCircleOutline size={22} color="#6C757D" />
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Block
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "bold", color: "#0784C3" }}
                      >
                        Age
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        From
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>To</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Amount
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Token
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: "bold", color: "#0784C3" }}
                      >
                        Txn Fee
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={12} align="center">
                          No data found
                        </TableCell>
                      </TableRow>
                    ) : (
                      tableData.map((row, index) => (
                        <TableRow key={row._id} hover>
                          <TableCell className="cell-style">
                            <Button
                              variant="outlined"
                              size="small"
                              style={{
                                backgroundColor: "#F8F9FA",
                                borderRadius: 8,
                                minWidth: "28px",
                              }}
                              onClick={() => handleOpenPopup(row)}
                            >
                              <FaEye style={{color:"gray"}} />
                            </Button>
                          </TableCell>
                          <TableCell
                            className="cell-style"
                            style={{ cursor: "pointer" }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <Tooltip title={row?.hash} arrow>
                                <span
                                  style={{ color: "#0784C3" }}
                                  onClick={() => {
                                    history.push(
                                      `/transactions_detail/${row?.hash}`
                                    );
                                  }}
                                >
                                  {row?.hash.length > 16
                                    ? `${row?.hash.substring(0, 8)}...${row?.hash.substring(row?.hash.length - 8)}`
                                    : row?.hash}
                                </span>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(row?.hash)}
                                style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>
                          </TableCell>
                          <TableCell className="cell-style">
                            {row.status === 1 ? "Success" : "Failed"}
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.tokenData && row?.tokenData?.method ? (
                              <>
                                <Tooltip
                                  title={
                                    row?.tokenData && row?.tokenData?.method
                                      ? row?.tokenData?.method
                                      : "N/A"
                                  }
                                  arrow
                                >
                                  <Button
                                    variant="outlined"
                                    color="default"
                                    size="small"
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "400",
                                      backgroundColor: "#F8F9FA",
                                      borderRadius: 8,
                                      textTransform: "capitalize",
                                      minWidth: "90px",
                                    }}
                                  >
                                    {row?.tokenData && row?.tokenData?.method
                                      ? row?.tokenData?.method
                                      : "N/A"}
                                  </Button>
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <Tooltip
                                  title={
                                    row?.tokenData &&
                                    row?.tokenData?.method === 1
                                      ? row?.tokenData?.method
                                      : "Transfer"
                                  }
                                  arrow
                                >
                                  <Button
                                    variant="outlined"
                                    color="default"
                                    size="small"
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "400",
                                      backgroundColor: "#F8F9FA",
                                      borderRadius: 8,
                                      textTransform: "capitalize",
                                      minWidth: "90px",
                                    }}
                                  >
                                    {row?.tokenData &&
                                    row?.tokenData?.method === 1
                                      ? row?.tokenData?.method
                                      : "Transfer"}
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </TableCell>
                          <TableCell
                            className="cell-style"
                            style={{ cursor: "pointer" }}
                          >
                            <span
                              style={{ color: "#0784C3", cursor: "pointer" }}
                              onClick={() => {
                                history.push(
                                  `/block_details/${row.blockNumber}`
                                );
                              }}
                            >
                              {row.blockNumber}
                            </span>
                          </TableCell>
                          <TableCell className="cell-style">
                            <Tooltip
                              title={localTimeConvert(row?.blockTimestamp)}
                              arrow
                            >
                              <span>{formatTimes(row?.blockTimestamp)}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className="cell-style" style={{ color: "#0784C3" }}>
                            {row?.tokenData && row?.tokenData.from ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.tokenData?.from} arrow>
                                  <Link
                                    to={`/address/${row?.tokenData?.from}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.tokenData?.from.length > 16
                                    ? `${row?.tokenData?.from.substring(0, 8)}...${row?.tokenData?.from.substring(row?.tokenData?.from.length - 8)}`
                                    : row?.tokenData?.from}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.tokenData?.from)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.from} arrow>
                                  <Link
                                    to={`/address/${row?.from}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.from.length > 16
                                    ? `${row?.from.substring(0, 8)}...${row?.from.substring(row?.from.length - 8)}`
                                    : row?.from}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.from)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            )}
                          </TableCell>
                          <TableCell className="cell-style" style={{ color: "#0784C3" }}>
                            {row?.tokenData && row?.tokenData.to ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.tokenData?.to} arrow>
                                  <Link
                                    to={`/address/${row?.tokenData?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.tokenData?.to.length > 16
                                    ? `${row?.tokenData?.to.substring(0, 8)}...${row?.tokenData?.to.substring(row?.tokenData?.to.length - 8)}`
                                    : row?.tokenData?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.tokenData?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.to} arrow>
                                  <Link
                                    to={`/address/${row?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.to.length > 16
                                    ? `${row?.to.substring(0, 8)}...${row?.to.substring(row?.to.length - 8)}`
                                    : row?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            )}
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.tokenData && row?.tokenData?.value != null ? (
                              <Tooltip
                                title={`${formatValue(row?.tokenData?.value)} ${
                                  row?.tokenData?.token
                                }`}
                                arrow
                              >
                                <span>
                                  {row?.tokenData
                                    ? `${formatValue(row?.tokenData?.value)}`
                                    : "N/A"}
                                  &nbsp;
                                </span>
                              </Tooltip>
                            ) : (
                              <Tooltip title={formatValue(row?.value)} arrow>
                                <span>
                                  {row?.value
                                    ? `${formatValue(row?.value)}`
                                    : "N/A"}
                                </span>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.tokenData && row?.tokenData?.token}
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.txnFee || 0}
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.tokenData && row?.tokenData?.value != null ? (
                              <Tooltip
                                title={`${formatValue(row?.tokenData?.value * 0.0006538)} ${
                                  row?.tokenData?.token
                                }`}
                                arrow
                              >
                                <span>
                                  {row?.tokenData
                                    ? `${formatValue(row?.tokenData?.value * 0.0006538)}`
                                    : "N/A"}
                                  &nbsp;
                                </span>
                              </Tooltip>
                            ) : (
                              <Tooltip title={formatValue(row?.value * 0.0006538)} arrow>
                                <span>
                                  {row?.value
                                    ? `${formatValue(row?.value * 0.0006538)}`
                                    : "N/A"}
                                </span>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              )}

              {buttonType == "2" && (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Rank
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Address
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Quantity
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Percentage
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Amount
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {holdersData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          No data found
                        </TableCell>
                      </TableRow>
                    ) : (
                      holdersData.map((row, index) => (
                        <TableRow key={row._id} hover>
                          <TableCell className="cell-style">
                            {index + 1 + page * rowsPerPage}
                          </TableCell>
                          <TableCell
                            className="cell-style"
                            style={{ color: "#0784C3" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <Tooltip title={row?.address} arrow>
                                <span> {row?.address} </span>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(row?.address)}
                                style={{
                                  marginLeft: 10,
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.quantity || 0}
                          </TableCell>
                          <TableCell className="cell-style" style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <LinearProgressBarWithLabel
                                value={(row?.heweBalance / cardValue?.totalSupply) * 100 || 0}
                                width="50%" // Adjust width as needed
                              />
                            </div>
                          </TableCell>
                          <TableCell className="cell-style">
                            {row?.heweBalance || 0}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>

            {/* Popup/Modal Dialog */}
            <Dialog
              open={showPopup}
              onClose={handleClosePopup}
              maxWidth="xs" // You can change this to 'sm', 'xs', 'md', 'lg', 'xl' as needed
              fullWidth // Ensures the dialog will take up the full width up to maxWidth
            >
              <DialogTitle>Additional Info</DialogTitle>
              <DialogContent>
                {popupData ? (
                  <>
                    <div className="popup-section">
                      <div className="popup-title">Status:</div>
                      <div className="popup-value">
                        {popupData.status === 1 ? (
                          <span style={{ color: "green" }}>Success</span> 
                        ) : (
                          <span style={{ color: "#F13333" }}>Failed</span>
                        )}
                        {" "}({popupData?.blockNumber || 0} Block Confirmation)
                      </div>
                    </div>

                    <hr />

                    <div className="popup-section">
                      <div className="popup-title">Transaction Action:</div>
                      <div className="popup-value">
                        <span style={{textTransform:"capitalize"}}>{popupData?.tokenData?.method}</span>{" "}
                        <span style={{ color: "#000000" }}> {popupData?.txnFee || 0} </span> (${popupData?.tokenData?.value || 0})
                        <span style={{ color: "#0584C3" }}> {popupData?.tokenData?.from} </span>{" "}
                        To
                        <span style={{ color: "#0584C3" }}>
                          {" "}{popupData?.tokenData?.to}
                        </span>
                      </div>
                    </div>

                    <hr />

                    <div className="popup-section">
                      <div className="popup-title">Transaction Fee:</div>
                      <div className="popup-value">
                        <span style={{ color: "#000000" }}>{popupData?.txnFee || 0} {popupData?.tokenData?.token}</span>
                        {" "}(${popupData?.tokenData?.value || 0})
                      </div>
                    </div>

                    <hr />

                    <div className="popup-section">
                      <div className="popup-title">Gas info:</div>
                      <div className="popup-value">
                        <span style={{ color: "#000000" }}>
                          29,703 gas used from 90,000 limit
                        </span>{" "}
                        <br />@ 0.00007 HEWE (4 Gwei)
                      </div>
                    </div>

                    <hr />

                    <div className="popup-section">
                      <div className="popup-title">Nonce:</div>
                      <div className="popup-value">
                        <span style={{ color: "#000000" }}>82 </span>
                        (in the position 90)
                      </div>
                    </div>

                    <hr />

                    <div className="popup-section">
                      <div className="popup-value">
                        <Link
                          to={`/transactions_detail/${popupData?.hash}`}
                          style={{ color: "#0584C3", textDecoration: "none" }}
                        >
                          See more details <GoArrowUpRight />
                        </Link>
                      </div>
                    </div>
                  </>
                ) : (
                  <p>Loading...</p>
                )}
              </DialogContent>
            </Dialog>

            {/* <div className="view-all-blocks-cant">
                <Link to="/new_transactions" style={{ textDecoration: "none" }}>
                <span className="view-all-blocks">View All Transaction</span>
                <i
                    className="pi pi-arrow-right"
                    style={{ fontSize: "10px", color: "#FFFFFF" }}
                ></i>
                </Link>
            </div> */}
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={buttonType == "1" ? totalCount : holderTotalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}

        <div className="add-bottom-content">
          <p className="last-block-content">
            <img src={bulb} alt="logo" height={12.5} width={12.5} />A token is a
            representation of an on-chain or off-chain asset. The token page
            shows information such as price, total supply, holders, transfers
            and social links. Learn more about this page in our Knowledge Base.
          </p>

          {buttonType == "1" && (
            <div className="csv-download">
              [ Download:{" "}
              <CSVLink
                data={exportedData}
                filename={"data.csv"}
                style={{
                  color: "#0784C3",
                  textDecoration: "none",
                  marginLeft: "4px",
                }}
              >
                CSV Export
                <img
                  src={csvicon}
                  style={{ height: "12px", width: "12px", margin: "0px 4px" }}
                  alt="CSV icon"
                />
              </CSVLink>
              ]
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HeweTransactions;
